import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const overlayButtonFn = /* @__PURE__ */ createRecipe('overlay-button', {}, [])

const overlayButtonVariantMap = {}

const overlayButtonVariantKeys = Object.keys(overlayButtonVariantMap)

export const overlayButton = /* @__PURE__ */ Object.assign(memo(overlayButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'overlayButton',
  __getCompoundVariantCss__: overlayButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: overlayButtonVariantKeys,
  variantMap: overlayButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, overlayButtonVariantKeys)
  },
  getVariantProps: overlayButtonFn.getVariantProps,
})